// Generated by purs version 0.15.15
import * as Data_Coordinates from "../Data.Coordinates/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Coordinates.eqCoordinates);
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Restaurant_Types_Id.eqRestaurantId));
var coordinatesIsSymbol = {
    reflectSymbol: function () {
        return "coordinates";
    }
};
var restaurantIdIsSymbol = {
    reflectSymbol: function () {
        return "restaurantId";
    }
};
var ReverseGeocodeRequestIsSymbol = {
    reflectSymbol: function () {
        return "ReverseGeocodeRequest";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var ReverseGeocodeRequest = function (x) {
    return x;
};
var toFillFormTypeReverseGeoc = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var rPCSitesReverseGeocodeReq = {};
var rPCMethodNameReverseGeoco = {
    rpcMethodName: function (v) {
        return "ReverseGeocodeRequest";
    }
};
var newtypeReverseGeocodeRequ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldReverseGeocodeReq = function (dictHasField) {
    return dictHasField;
};
var eqReverseGeocodeRequest = {
    eq: function (x) {
        return function (y) {
            return eq(x.coordinates)(y.coordinates) && eq1(x.restaurantId)(y.restaurantId);
        };
    }
};
var genericReverseGeocodeRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showReverseGeocodeRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericReverseGeocodeRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(coordinatesIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(restaurantIdIsSymbol)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Restaurant_Types_Id.showRestaurantId)))(Data_Coordinates.showCoordinates))))(ReverseGeocodeRequestIsSymbol))
};
var unscrambleDecodeReverseGeocodeRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericReverseGeocodeRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(coordinatesIsSymbol)(Data_Coordinates.unscrambleDecodeCoordinates)(/* #__PURE__ */ Unscramble.decodeRecordCons(restaurantIdIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Restaurant_Types_Id.udecodeRestaurantId))(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var encodeReverseGeocodeRequest = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericReverseGeocodeRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ReverseGeocodeRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(restaurantIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Restaurant_Types_Id.encodeRestaurantId))))(coordinatesIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Coordinates.encodeCoordinates))))))
};
var decodeReverseGeocodeRequest = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericReverseGeocodeRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ReverseGeocodeRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(restaurantIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Restaurant_Types_Id.decodeRestaurantId)))())(coordinatesIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Coordinates.decodeCoordinates))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    ReverseGeocodeRequest,
    genericReverseGeocodeRequest,
    eqReverseGeocodeRequest,
    showReverseGeocodeRequest,
    rPCMethodNameReverseGeoco,
    rPCSitesReverseGeocodeReq,
    encodeReverseGeocodeRequest,
    decodeReverseGeocodeRequest,
    unscrambleDecodeReverseGeocodeRequest,
    toFillFormTypeReverseGeoc,
    hasFieldReverseGeocodeReq,
    newtypeReverseGeocodeRequ
};
